(function () {
    'use strict';

    angular
        .module('aeroLineCrew')
        .config(config)
        .run(run);

    function config($urlRouterProvider) {
        $urlRouterProvider.otherwise('/login');
    }

    function run($rootScope, $state, AuthService, ApplicationService, Idle, Keepalive,StorageServices) {
        var onStateChange = $rootScope.$on('$stateChangeStart', function (event, toState) {


            var isLoggedIn = AuthService.isLoggedIn();

            if (!isLoggedIn) {
                 if (toState.name !== 'login' && toState.name !== 'reset' && toState.name !== 'sso-callback' && toState.name !== 'crewSignInScreen' && toState.name !== 'flightScreen' && toState.name !== 'flightInformationReport' ) {
                    $state.go('login');
                    event.preventDefault();
                }
            } else if (toState.name === 'login') {
                $state.go('welcome');
                event.preventDefault();
            }
            else if(toState.name === 'crewSignInScreen'){

              $state.go('crewSignInScreen');
              event.preventDefault();
            }
            else if(toState.name === 'flightScreen'){

              $state.go('flightScreen');
              event.preventDefault();
            }
            else if(toState.name === 'flightInformationReport'){

                $state.go('flightInformationReport');
                event.preventDefault();
            }

            if (isLoggedIn) {
              Idle.watch();
              var adminTimeOut = ApplicationService.getLoginInfo().timeToLeave;
              Idle.setIdle(adminTimeOut*60);
              Idle.setTimeout(180);
              Keepalive.setInterval(adminTimeOut*60);
            } else {
              Idle.unwatch();
            }

            ApplicationService.openInTabbedView(toState.name);

        });
    }
}());
